export default __webpack_public_path__ + "static/media/horizontalBusPlan.a7a34f56.svg";